import router from '@/router'
import api from '@/api'
import cookies from 'js-cookie'

router.beforeEach((to, from, next) => {
    next();
    // if (to.path == '/login') {
    //     next();
    // }else if (to.path == '/auth') {
    //     let code = to.query.code
    //     getAuthWechatUserInfo(code);
    // }else{
    //     if(to.path == '/start'){
    //         let dynamicCode = to.query.dynamiccode;
    //         cookies.set('dynamiccode', dynamicCode);
    //         console.log(dynamicCode);
    //     }
    //     var customer = cookies.get('customer');
    //     if (customer == undefined && customer == null) {
    //         verifyWechatUserInfo();
    //     } else {
    //         if(to.path == '/start'){
    //             next('/result');
    //         }else{
    //             next();
    //         }
            
    //     }
    // }
})

function verifyWechatUserInfo() {
    var wechatUserInfo = cookies.getJSON('wechatuserinfo');
    console.log(wechatUserInfo);

    if (wechatUserInfo == undefined || wechatUserInfo == null) {
        var redirect = 'http://' + location.host + '/#/auth';
        var targetUrl = 'http://api.skin.opentmh.com/wechat/auth/applyauth?appkey=wxccde569fb0bdcf86&type=2&redirect=' + encodeURIComponent(redirect);
        location.href = targetUrl;
    } else {
        searchUserInfo(wechatUserInfo.openid);
        console.log(wechatUserInfo.openid);
    }
}

function getAuthWechatUserInfo(code) {
    api.wechat.auth.getAuthWechatUserInfo('wxccde569fb0bdcf86', code).then(function (res) {
        if (res.data.success) {
            cookies.set('wechatuserinfo', res.data.result);
            searchUserInfo( res.data.result.openid);
        } else {
            next();
        }
    });
}
function searchUserInfo(openId) {
    api.wechat.userinfo.searchUserInfo(openId,1).then(function (res) {
        console.log(res);
        if (res.data.success) {
            searchCustomer(res.data.result.userinfo.customercode);
        }else{
            router.push({ path: '/login' });
        }
    })
}

function searchCustomer(code) {
    api.customer.customer.searchCustomer(code).then(function (res) {
        if (res.data.success) {
            cookies.set('customer', res.data.result.customer);
            router.push({ path: '/result' });
        } else {
            var wechatUserInfo = cookies.getJSON('wechatuserinfo');
            if (wechatUserInfo == undefined || wechatUserInfo == null) {
                var redirect = 'http://' + location.host + '/#/visableauth';
                var targetUrl = 'http://api.store.idaojia.net/wechat/auth/applyauth?appkey=wx615c79017a61bd63&type=2&redirect=' + encodeURIComponent(redirect);
                location.href = targetUrl;
            } else {
                router.push({ path: '/login' });
            }
        }
    })
}


// WEBPACK FOOTER //
// ./src/config/filterRouter.js